import CouponcodeApplicationsList from "./couponcodeApplicationsList";
export default {
  list: CouponcodeApplicationsList,
};
